import * as React from 'react';
import './index.scss';
import { Form, Input, Button, message } from 'antd';
import queryString from 'querystring';
import { requestRetrieve } from '../../model/api';

export default class Retrieve extends React.Component {
  _formItemLayout = {
    labelCol: {
      xs: { span: 12 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 12 },
      sm: { span: 16 },
    }
  }

  _tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 4,
      },
    },
  };

  constructor(props) {
    super(props);
    
    this.state = {
      email: null,
      src: null,
      token: null
    }
    this.handleFinish = this.handleFinish.bind(this);
  }

  componentDidMount() {
    const parsed = queryString.parse(window.location.search.substr(1));
    this.setState({ 
      email: parsed.email || "",
      src: parsed.src || null,
      token: parsed.token || ""
    })
  }

  handleFinish(values) {
    if(values.password) {
     let password = values.password;
      requestRetrieve(this.state.email, password, this.state.src, this.state.token).then(data => {
        if(data && data.status) {
          // this.props.history.push('/');
          window.location.href=('/')
        }else {
          message.error("校验失败!");
        }
      })
    }
  }

  render() {
    console.log(this.state);
    return (
      <div className='retrieve'>
        <div className='panel'>
          <div className='top_line' />
        </div>
        <div className='inner'>
          <div className='title'>初始化密码</div>
          <div className='bottom'>
              <Form 
                {...this._formItemLayout}
                onFinish={this.handleFinish}>
                <Form.Item name='email' label='邮箱:'>
                  <div>{this.state.email}</div>
                </Form.Item>
                <Form.Item 
                  name='password'
                  label='密码:'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your password!'
                    }
                  ]}>
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name='confirm'
                  label='确认密码:'
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password!'
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject('The two passwords that you entered do not match!');
                      },
                    }),
                  ]}>
                  <Input.Password />
                </Form.Item>
                <Form.Item {...this._tailFormItemLayout}>
                  <Button type='primary' htmlType='submit' className='submit'>
                    确定
                  </Button>
                </Form.Item>
              </Form>
          </div>
        </div>
      </div>
    )
  }
}